import React from 'react'

export interface BaseIconProps {
  className?: string
  viewBox?: string
  width?: string
  minWidth?: number
  height?: string
  gradient?: boolean
  children?: React.ReactNode
}

export const BaseIcon: React.FC<BaseIconProps> = ({
  className,
  viewBox = '0 0 24 24',
  width = '24px',
  height = '24px',
  minWidth,
  gradient,
  children,
}) => {
  const style = React.useMemo(
    () => (minWidth ? { minWidth } : undefined),
    [minWidth],
  )

  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={width}
      height={height}
      style={style}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      {children}

      {gradient && (
        <defs>
          <linearGradient x1="100%" y1="100%" x2="0%" y2="0%" id="gradient">
            <stop stopColor="#FF8255" offset="0%"></stop>
            <stop stopColor="#FF0082" offset="63.1466427%"></stop>
            <stop stopColor="#C20098" offset="100%"></stop>
          </linearGradient>
        </defs>
      )}
    </svg>
  )
}

export const iconFactory = <P extends { fill?: string }>(
  name: string,
  Component: React.FC<P>,
  defaultProps?: Partial<BaseIconProps>,
): React.FC<P & BaseIconProps> => {
  Component.displayName = `${name}Inner`

  const Icon = (props: P & BaseIconProps) => (
    <BaseIcon {...defaultProps} {...props}>
      <Component
        {...defaultProps}
        {...props}
        fill={props.gradient ? 'url(#gradient)' : props.fill ?? 'currentColor'}
      />
    </BaseIcon>
  )

  Icon.displayName = name

  return Icon
}
